import axios from '@/plugins/axios';

const BASE_URL = '/api/campaigns/';

/**
 * Sube una imagen al backend para usarla en el cuerpo de una campaña.
 * @param {File} file - Archivo de imagen (jpeg, png, gif, webp, máx 2 MB)
 * @returns {Promise<{ url: string }>} URL pública de la imagen
 */
export async function uploadCampaignImage(file) {
  const { key } = JSON.parse(localStorage.getItem('user') || '{}');
  const formData = new FormData();
  formData.append('image', file);

  const response = await axios.post('/api/campaigns/upload-image/', formData, {
    headers: {
      Authorization: `Token ${key}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

export default {
  /**
   * Obtiene la lista de todas las campañas
   * @returns {Promise<Array>}
   */
  async obtenerCampanas() {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
    };
    const response = await axios.get(BASE_URL, config);
    return response.data;
  },

  /**
   * Obtiene el detalle de una campaña específica
   * @param {number} id - ID de la campaña
   * @returns {Promise<Object>}
   */
  async obtenerCampana(id) {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
    };
    const response = await axios.get(`${BASE_URL}${id}/`, config);
    return response.data;
  },

  /**
   * Crea una nueva campaña con sus variantes
   * @param {Object} datos - Datos de la campaña
   * @returns {Promise<Object>}
   */
  async crearCampana(datos) {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
    };
    const response = await axios.post(BASE_URL, datos, config);
    return response.data;
  },

  /**
   * Actualiza una campaña existente
   * @param {number} id - ID de la campaña
   * @param {Object} datos - Datos actualizados
   * @returns {Promise<Object>}
   */
  async actualizarCampana(id, datos) {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
    };
    const response = await axios.put(`${BASE_URL}${id}/`, datos, config);
    return response.data;
  },

  /**
   * Elimina una campaña
   * @param {number} id - ID de la campaña
   * @returns {Promise<void>}
   */
  async eliminarCampana(id) {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
    };
    await axios.delete(`${BASE_URL}${id}/`, config);
  },

  /**
   * Activa o desactiva una campaña
   * @param {number} id - ID de la campaña
   * @returns {Promise<Object>}
   */
  async toggleActivo(id) {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
    };
    const response = await axios.post(`${BASE_URL}${id}/toggle_activo/`, {}, config);
    return response.data;
  },

  /**
   * Obtiene métricas detalladas de una campaña
   * @param {number} id - ID de la campaña
   * @returns {Promise<Object>}
   */
  async obtenerMetricasDetalladas(id) {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
    };
    const response = await axios.get(`${BASE_URL}${id}/metricas-detalladas/`, config);
    return response.data;
  },

  /**
   * Exporta la lista de campañas y sus métricas en formato Excel.
   * @returns {Promise<import('axios').AxiosResponse<Blob>>}
   */
  async exportarCampanas() {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
      responseType: 'blob',
    };

    return axios.get(`${BASE_URL}exportar/`, config);
  },

  /**
   * Envía un correo de prueba con datos mock
   * @param {Object} datos - { email_destinatario, asunto, cuerpo, variante_id }
   * @returns {Promise<Object>}
   */
  async enviarCorreoPrueba(datos) {
    const { key } = JSON.parse(localStorage.getItem('user') || '{}');
    const config = {
      headers: { Authorization: `Token ${key}` },
    };
    const response = await axios.post('/api/campaign/test-email', datos, config);
    return response.data;
  }
};
